<div class="flex flex-col mb-6">
  <h2 class="font-bold text-center">Accede al vídeo resumen de tu informe.</h2>
</div>

<form class="flex flex-col" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
  <div class="flex flex-col gap-2 mb-6">
    <label for="rut" class="text-sm text-gray-900">Ingresa tu RUT sin puntos ni guión</label>
    <input
      #rutInput
      rutFormatGuion
      placeholder="12.345.678-9"
      id="rut"
      type="text"
      formControlName="rut"
      maxlength="12"
      autocomplete="off"
      spellcheck="false"
      class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      [class.border-red-500]="hasError()"
    />
    @if (hasError() && errorMessage()) {
      <div class="text-red-600 text-sm mt-1">
        {{ errorMessage() }}
      </div>
    }
    @if (isCoolingDown()) {
      <div class="text-orange-600 text-sm mt-1">
        Demasiados intentos fallidos. Podrás intentarlo nuevamente en {{ cooldownSeconds() }}s.
      </div>
    }
  </div>
  <button
    mat-raised-button
    color="primary"
    type="submit"
    [disabled]="loginForm.invalid || isLoading || isCoolingDown()"
    [class.opacity-50]="loginForm.invalid || isLoading"
    [class.cursor-not-allowed]="loginForm.invalid || isLoading || isCoolingDown()"
    [class.bg-gray-400!]="isCoolingDown()"
    [class.bg-navy!]="!isCoolingDown()"
    class="text-white! w-[320px] self-center min-h-12 text-lg! font-bold! transition-all duration-300"
  >
    Continuar
  </button>
</form>
